// extracted by mini-css-extract-plugin
export default {"image":"CommunityLogo_image__tYqBM"};